<template>
	<v-dialog persistent @click:outside="closeDialog()" v-model="dialog" max-width="700" content-class="test-class">
		<v-card >
			<v-card-title>
				{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.photo.header')}}
				<v-btn icon @click="closeDialog()" class="ml-auto">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="py-3">
				<div v-if="file" class="text-center">
					<vue-croppie
						v-if="file"
                        ref="croppieRef"
                        :enableOrientation="true"
                        :enforceBoundary="true"
                        :enableExif="true"
                        :enableResize="true"
                        :backgroundColor="'#FFFFFF'"
						:boundary="boundary"
						:viewport="viewport"
                        @result="result">
                    </vue-croppie>
					<div class="mt-3">
						<v-btn color="secondary" @click="resetImage()" elevation="0"><v-icon>mdi-sync</v-icon> {{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.photo.getAnother') }}</v-btn>
					</div>
				</div>
				<div v-if="!file" class="drop-area text-center relative" :class="{dragging: dragging}" @dragover="dragging=true" @dragend="dragging=false">
						<input type="file" accept="image/*" id="upload-image__fileInput" class="fileinput" @change="addFile"/>
						<label class="my-5 v-btn v-btn--has-bg theme--light elevation-0 v-size--x-large accent" for="upload-image__fileInput">
							{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.photo.get') }}
						</label>
						<div class="font-16 bold">
							{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.photo.drag')}}
						</div>
						<div class="mt-3 text-accent font-14">
							{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.photo.info')}}
						</div>
					</div>
			</v-card-text>
			<v-card-actions class="justify-content-center py-7">
				<v-btn color="light" elevation="0" @click="closeDialog()">{{ $vuetify.lang.t('$vuetify.cancel')}}</v-btn>
				<v-btn color="accent" elevation="0" @click="save()" :disabled="!image">{{ $vuetify.lang.t('$vuetify.choose')}}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import {mapGetters} from 'vuex';
// import ImageUploader from 'vue-image-upload-resize'
export default {
	name: 'AttachImageDialog',
	components: {
		// ImageUploader
	},
	props: {
		resultWidth: {
			type: [Boolean, Number],
			default: null
		},
		circle: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			dialog: false,
			hasImage: false,
			newPhoto: {},
			imgkey: 0,
			dragging: false,
			cropped: null,
			boundaryWidth: 400,
			file: null,
			image: null,
			boundary: {
				width: 510,
				height: 310
			},
			viewport: {
				width: 500,
				height: this.circle ? 500 : 300,
				type: this.circle ? 'circle' : 'square'
			},
			originalFileWidth: null,
			originalFileHeight: null,
		}
	},
	computed: {
		...mapGetters({
			imageValidation: 'validation/images'
		}),
	},
	methods: {
		getFinalSize() {
			let w = null;
			let h = null;
			let ret = null;

			if(this.resultWidth) {
				w = this.resultWidth;
				ret =  {width: w,height: h};
			}
			else {
				if(this.originalFileWidth || this.originalFileHeight) {
					if(this.originalFileWidth > this.originalFileHeight) {
						if(this.originalFileWidth > 1920) {
							w = 1920;
						}
						else {
							w = this.originalFileWidth;
						}
					}
					else {
						if(this.originalFileHeight > 1920) {
							h = 1920;
						}
						else {
							h = this.originalFileHeight;
						}
						
					}
					ret =  {width: w,height: h};
				}
				else {
					ret = 'original';
				}
			}
			return ret;
		},
		save() {
			if(this.file) {
				this.$refs.croppieRef.result({
					size: this.getFinalSize(),
					quality: 0.7,
					format: 'jpeg'
				}, (output) => {
					this.cropped = output;
					this.$emit('selected', this.cropped);
					this.closeDialog();
					this.imgkey++;
					return true;
				});
			}
			else {
				this.$toast.error('Wybierz zdjęcie!');
			}

		},
		showDialog() {
			this.dialog = true;
		},

		closeDialog() {
			this.hasImage = false;
			this.newPhoto = {};
			this.imgkey++;
			this.dialog = false;
			this.$emit('closed');
		},
		addFile(e){
			const file = Array.from(e.target.files)[0];
			this.file = file;
			const reader = new FileReader();

			reader.onload = (e) => {
				const img = new Image();
				img.src = e.target.result;
				
				this.image = e.target.result;
				const t = this
				img.onload = function() {
					t.originalFileWidth = img.width;
					t.originalFileHeight = img.height;
					t.$refs.croppieRef.bind({
						url: e.target.result,
						format: 'jpeg'
					});
				}
				
			};
			
			reader.readAsDataURL(file);
			
		},
		resetImage() {
			this.file = null;
            this.image = null;
			this.imgkey++;
		},
		result(output) {
			console.log("RESULT!", output)
			this.cropped = output;
		},
	}
}
</script>

<style lang="scss" scoped>
	.img-preview {
		height: 40vh;
	}
</style>
